const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@!#])[A-Za-z\d@!#-_]{8,}$/;

export const isValidPassword = (password: string) => passwordRegex.test(password)